import { makeContactValidators } from '~/business-logic/validators';
import { useValidationRules } from '~/hooks/useValidationRules/useValidationRules';
import { useLocaleKeys } from '~/i18n';
export function useContactValidators() {
    const validators = useValidationRules();
    const { t: contactValidationTexts } = useLocaleKeys('client.contactValidation');
    return makeContactValidators({
        validators,
        texts: contactValidationTexts
    });
}
